<template>
  <b-modal size="lg" ref="modal" @close="close" centered no-close-on-backdrop>
    <template #modal-header="{ close }">
      <div class="d-flex justify-content-between align-items-center w-100"> 
        <div></div>
        <h5 class="text-centerfont-weight-bolder m-0">Company Details</h5>
        
        <b-button
          size="sm"
          variant="none"
          class="btn-icon btn-circle btn-hover-dark"
          title="Close"
          @click="close"
          v-b-tooltip.hover
          >
          <i class="material-icons icon-xl">close</i>
        </b-button>
      </div>
    </template>

    <template #default v-if="fetching">
      <div class="d-flex align-items-center justify-content-center">
        Loading...
      </div>
    </template>
    <template #default v-else>
      <b-row class="d-flex justify-content-center mx-2">
        <div
        class="alert text-center font-weight-bolder"
        :class="variants"
        v-if="error && error.length"
        >
        {{ error }}
      </div>
      </b-row>
      <b-row class="d-flex justify-content-center mx-2"> 
        <b-col class="col-6"> 
          <div class="row mb-3 d-flex align-items-center">
            <div class="col-5 font-weight-bolder text-right">Name</div>
            <div class="col-7" style="overflow-wrap: break-word;">
              {{ company.name }}
            </div>
          </div>
          
          <div class="row mb-3 d-flex align-items-center">
            <div class="col-5 font-weight-bolder text-right">Country</div>
            <div class="col-7">{{ company.country || "-" }}</div>
          </div>
          
          <div class="row mb-3 d-flex align-items-center">
            <div class="col-5 font-weight-bolder text-right">Currency</div>
            <div class="col-7">{{ company.base_currency || "-" }}</div>
          </div>

          <div class="row mb-3 d-flex align-items-center">
            <div class="col-5 font-weight-bolder text-right">Admin Name</div>
            <div class="col-7" style="overflow-wrap: break-word;">{{ company.admin_user.first_name || "-" }}</div>
          </div>

        
            <div class="row mb-3 d-flex align-items-center">
              <div class="col-5 font-weight-bolder text-right">Admin Email</div>
              <div class="col-7" style="overflow-wrap: break-word;">{{ company.admin_user.email || "-" }}</div>
            </div>
          <div v-if="company.is_merchant"> 
            <div class="row mb-3 d-flex align-items-center">
              <div class="col-5 font-weight-bolder text-right">Invoice Count</div>
              <div class="col-7">{{ analytics.invoices_analytics.invoices_count || "-" }}</div>
            </div>

          <div class="row mb-3 d-flex align-items-center">
            <div class="col-5 font-weight-bolder text-right">Invoice Volume</div>
            <div class="col-7">
              AED {{ new Intl.NumberFormat("en-US", {
                      style: "decimal",
                      roundingIncrement: 5,
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }).format(analytics.invoices_analytics.invoices_sum_AED) || "-" 
                  }}
            </div>
          </div>
          <div class="row mb-3 d-flex align-items-center">
            <div class="col-5 font-weight-bolder text-right">Status</div>
            <div class="col-7">
              <div
                class="label label-inline label-light-danger font-weight-bolder py-4"
                v-if="!company.active"
                >
                INACTIVE
              </div>
              <div
                class="label label-inline label-light-success font-weight-bolder py-4"
                v-else
                >
                ACTIVE
              </div>
            </div>
          </div>
          <div class="row mb-3 d-flex align-items-center">
            <div class="col-5 font-weight-bolder text-right">News Letter</div>
            <div class="col-7"  @click="previewNewsLetter()">
              <div class="label label-inline label-dark-secondary font-weight-bolder py-4">
                Preview
            </div> 
          </div>
          </div>
        </div>

          
        </b-col>
        <b-col class="col-5">
          <div class="row mb-3">
            <div class="col-9 font-weight-bolder text-left">Merchant</div>
            <b-form-checkbox v-model="company.is_merchant" switch> </b-form-checkbox>
          </div>
          <div class="row mb-3">
            <div class="col-9 font-weight-bolder text-left">Show Privacy Policy</div>
            <b-form-checkbox v-model="company.show_privacy_policy" switch> </b-form-checkbox>
          </div>
          <div class="row mb-3">
            <div class="col-9 font-weight-bolder text-left">Allow Integrations</div>
            <b-form-checkbox v-model="company.allow_integrations" switch> </b-form-checkbox>
          </div>
          <div class="row mb-3">
            <div class="col-9 font-weight-bolder text-left">Enable bank payments</div>
            <b-form-checkbox v-model="company.enable_bank_payments" switch> </b-form-checkbox>
          </div>
          <div class="row mb-3">
            <div class="col-9 font-weight-bolder text-left">Partial pay with bank</div>
            <b-form-checkbox v-model="company.partial_payments_on_banks" switch> </b-form-checkbox>
          </div>
          <div class="row mb-3">
            <div class="col-9 font-weight-bolder text-left">Partial pay with cards</div>
            <b-form-checkbox v-model="company.partial_payments_on_cards" switch> </b-form-checkbox>
          </div>
          <div class="row mb-3">
            <div class="col-9 font-weight-bolder text-left">Bypass Buyer Signup</div>
            <b-form-checkbox v-model="company.bypass_buyer_signup" switch> </b-form-checkbox>
          </div>
          <div class="row mb-3">
            <div class="col-9 font-weight-bolder text-left">Allow Account Integrations</div>
            <b-form-checkbox v-model="company.allow_account_integrations" switch> </b-form-checkbox>
          </div>
          <div class="row mb-3">
            <div class="col-9 font-weight-bolder text-left">Send Monthly NewsLetter</div>
            <b-form-checkbox v-model="company.send_monthly_newsletter" switch> </b-form-checkbox>
          </div>
        </b-col>
      </b-row>
    </template>

    <template #modal-footer="{ close }">
      <div class="d-flex justify-content-between mx-auto">
        <b-button
          class="btn-pill font-weight-bold mr-2"
          variant="dark"
          :disabled="disabled"
          @click="close"
        >
          <span>Close</span>
        </b-button>
        <b-button
          class="btn-pill font-weight-bold"
          variant="dark"
          :disabled="disabled"
          @click="()  => {editBusiness(); close();}"
        >
          <span>Save</span>
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import AnalyticsService from "@/services/analytics.service";
import CompaniesService from "@/services/companies.service";
import EnumeratesService from "@/services/enumerates.service";
export default {
  name: "Details",
  methods: {
    async fetch(id) {
      this.fetching = true;

      CompaniesService.get(id)
        .then(async ({ data }) => {
          this.company = data;

          const country_data = await EnumeratesService.countries();

          if (country_data?.data?.length) {
            const rec = country_data.data.find(
              (each) => each.id === data?.country
            );
            if (rec?.name) this.company["country"] = rec?.name;
          }

          const currency_data = await EnumeratesService.currencies();

          if (currency_data?.data?.length) {
            const rec = currency_data.data.find(
              (each) => each.id === data?.base_currency
            );
            if (rec?.name) this.company["base_currency"] = rec?.name;
          }
        })
        .catch(({ message }) => {
          this.error = message;
        })
        .finally(() => {
          this.fetching = false;
        });
    },
    open(business) {
      this.error = null;
      this.fetching = false;
      this.company = business;
      this.$refs["modal"].show();
    },
    close(){
      this.$refs['modal'].hide()
    },
    previewNewsLetter(){
      if(this.company.send_monthly_newsletter == true){
        this.$emit('preview');
      }
      else{
        this.error = 'No subscription for newsletter';
      }
      
    },
    editBusiness() {
      
      CompaniesService.patch(this.company.id,
        {
          'is_merchant': this.company.is_merchant,
          'allow_integrations': this.company.allow_integrations,
          'enable_bank_payments': this.company.enable_bank_payments,
          'partial_payments_on_banks': this.company.partial_payments_on_banks,
          'partial_payments_on_cards': this.company.partial_payments_on_cards,
          'bypass_buyer_signup': this.company.bypass_buyer_signup,
          'show_privacy_policy': this.company.show_privacy_policy,
          'allow_account_integrations': this.company.allow_account_integrations,
          'send_monthly_newsletter': this.company.send_monthly_newsletter,
        }
      )
      .catch((err) => console.log(err));
    },
  },
  computed: {
    disabled() {
      return this.sending;
    },
    variants() {
      return {
        show: this.error,
        "alert-light-danger": this.error,
      };
    },
  },
  watch: {
    company(newval) {
      if(newval.id) {
        this.fetching = true;
        AnalyticsService.get('merchants',{"id": this.company.id})
        .then(({data}) => {
          this.analytics = data.current;
        })
        .catch((err) => console.log(err))
        .finally(() => {
          this.fetching = false;
        });
      }
    }
  },
  data() {
    return {
      error: null,
      fetching: false,
      company: {},
      analytics: null,
    };
  },
};
</script>
